import { render } from "./VShape.vue?vue&type=template&id=3f43686e&scoped=true"
import script from "./VShape.vue?vue&type=script&lang=js"
export * from "./VShape.vue?vue&type=script&lang=js"

import "./VShape.vue?vue&type=style&index=0&id=3f43686e&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f43686e"]])

export default __exports__